module.exports = __webpack_public_path__ + "img/blue-tic.1f5c342f.svg";